import { render, staticRenderFns } from "./Exit.vue?vue&type=template&id=4812eca0&"
import script from "./Exit.vue?vue&type=script&lang=ts&"
export * from "./Exit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports